export const trackEvent = (eventName, eventData = {}) => {
  if (!eventName || typeof eventName !== "string") {
    return;
  }

  const analyticsPayload = {
    event: eventName,
    data: eventData,
    timestamp: new Date().toISOString(),
  };

  // Facade for future analytics providers (GA4, Mixpanel, etc.).
  // eslint-disable-next-line no-console
  console.log("[analytics]", analyticsPayload);
};

export default trackEvent;
